module.exports = __webpack_public_path__ + "static/media/14.f469cda5.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/14.JPG
// module id = 456
// module chunks = 0